<div class='search-tab'>
  <input *ngIf="isValue" type="search" id='searchId' [(ngModel)]="searchTerm" placeholder="Search here" (input)="onSearchChange()">
  <button type="button" class="btn filter-btn" data-bs-toggle="modal" data-bs-target="#filterModal">
    <i class="fa fa-filter" aria-hidden="true"></i> Filter
  </button>
</div>

<div class="imgDiv" *ngIf="noData">
  <img src="../../../../assets/images/template_img.svg" alt="" id="noDataImg">
</div>

<div *ngIf="responseData?.length > 0">
  <div *ngFor="let item of responseData; let i = index" >
    <div class="card" (click)="handleCardClick($event, item.id)">
      <div class="card-body">
        <div class='card-head'>
          <p class="card-text"><span class='card_title'>SrNo : </span>{{i+1}}</p>
          <p class="card-text"><span class='card_title'>ID : </span>{{item.id}}</p>
        </div>

        <div class='seperateDiv'>
          <div class='subjectDiv'>
            <div class="itemInfo">
              <ng-container *ngFor="let value of visible_to">
                <p class="card-text"><span class="card_title">{{value.title}} : </span>{{item.values[value.id]}}</p>
              </ng-container>
            </div>
          </div>

          <div class='buttonsDiv'>
            <button type="button" class="btn space" (click)="handleEditButtonClick($event, item.id)">
              <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
            </button>
            <button type="button" class="btn space" (click)="downloadFile($event, item.id)">
              <i class="fa fa-solid fa-download"></i>
            </button>


          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Move the button outside of the *ngFor loop -->
<!-- <div class="position-fixed  end-0 p-3 " *ngIf="insuranceBtn" id="addValueBtn">
    <button id="addBtn" class="btn" (click)="navigate()">Add Insurance</button>
</div> -->

<!-- Filter Modal -->
<div class="modal fade" id="filterModal" #filterModalRef tabindex="-1" aria-labelledby="filterModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="filterModalLabel">Filter</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="mb-3">
          <label for="entitySelect" class="form-label">Entity</label>
          <ng-select
            bindLabel="name"
            bindValue="name"
            placeholder="Search and Select entity"
            [items]="entities"
            [(ngModel)]="tempFilters.entity"
            [searchable]="true"
            [clearable]="true"
            class="filter-select"
          ></ng-select>
        </div>
        <div class="mb-3">
          <label for="financialYearPicker" class="form-label">Financial Year</label>
          <mat-form-field appearance="fill" class="w-100 year-picker-field">
            <input matInput [matDatepicker]="picker" [(ngModel)]="tempFilters.financialYear" (click)="picker.open()" placeholder="Select Year" readonly>
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker startView="multi-year" (yearSelected)="onYearSelected($event, picker)" panelClass="year-picker-panel"></mat-datepicker>
          </mat-form-field>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="clear-filter-btn" (click)="clearFilters()">Clear</button>
        <button type="button" class="apply-filter-btn" (click)="applyFilters()">Apply Filter</button>
      </div>
    </div>
  </div>
</div>

<!-- <button type="button" class="btn space">
              <i class="fa fa-trash" aria-hidden="true" (click)="handleDeleteButtonClick($event, item.id)"></i>
      </button> -->